const direction = sessionStorage.getItem('nav-direction');

if (direction) {
  document.documentElement.classList.add(direction);
  sessionStorage.removeItem('nav-direction');
  
  // Remove class after animation completes
  setTimeout(() => {
    document.documentElement.classList.remove(direction);
  }, 500);
}

// Detect back/forward button navigation
window.addEventListener('pageshow', (event) => {
  // Check if page was loaded from cache (back/forward navigation)
  if (event.persisted) {
    document.documentElement.classList.add('back');
    setTimeout(() => {
      document.documentElement.classList.remove('back');
    }, 500);
    return;
  }
  
  // Alternative check for back/forward navigation
  const navEntries = performance.getEntriesByType('navigation');
  if (navEntries.length > 0 && (navEntries[0] as PerformanceNavigationTiming).type === 'back_forward') {
    document.documentElement.classList.add('back');
    setTimeout(() => {
      document.documentElement.classList.remove('back');
    }, 500);
  }
});
